import { useRequestEvent } from "#imports";

export function useRequestProtocol () {
  let scheme: string;

  if ( import.meta.server ) {
    const requestEvent = useRequestEvent();
    const forwardedProto = requestEvent.node.req.headers["x-forwarded-proto"];
    if ( forwardedProto === "https" ) {
      scheme = "https";
    } else {
      scheme = ( requestEvent.node.req.connection as any )?.encrypted ? "https" : "http";
    }
  } else {
    scheme = window.location.protocol.replace( ":", "" );
  }

  return scheme;
}
